module.exports = "<app-menu></app-menu>"